import gql from 'graphql-tag';
import { DISCUSSION_MESSAGE_FRAGMENT } from './fragment';
export const NEW_MESSAGE_TO_DISCUSSION = gql`
  subscription NewMessageToDiscussion($discussionId: Int!) {
    newMessageToDiscussion(discussionId: $discussionId) {
      ...DiscussionMessageFragment
    }
  }
  ${DISCUSSION_MESSAGE_FRAGMENT}
`;
export const LISTEN_TO_GLOBAL_NEW_MESSAGE = gql`
  subscription GlobalNewMessageToDiscussion {
    globalNewMessageToDiscussion {
      ...DiscussionMessageFragment
    }
  }
  ${DISCUSSION_MESSAGE_FRAGMENT}
`;
